import React from "react";
import { X } from "lucide-react";

interface AdminModalProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  maxWidthClassName?: string;
}

/** Centered admin dialog: fits viewport height, scrollable body, sticky footer. */
export function AdminModal({
  title,
  onClose,
  children,
  footer,
  maxWidthClassName = "max-w-md",
}: AdminModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-3 sm:p-4">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden
      />
      <div
        role="dialog"
        aria-modal
        className={`relative bg-white rounded-2xl shadow-2xl w-full ${maxWidthClassName} max-h-[min(90vh,100dvh-1.5rem)] flex flex-col`}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100 flex-shrink-0">
          <h2 className="text-[15px] text-gray-900 pr-2">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 rounded-lg hover:bg-gray-100 text-gray-400"
          >
            <X size={18} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto overscroll-contain p-5 space-y-3 min-h-0">
          {children}
        </div>
        {footer ? (
          <div className="flex items-center justify-end gap-3 px-5 py-4 border-t border-gray-100 flex-shrink-0 bg-white rounded-b-2xl">
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
}
